import styles from "./styles.module.css";
import { saveClientInfos } from "../../../firebase";
import Box from "../../../components/Box"
import Button from "../../../components/Button"
import Input from "../../../components/Input"
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi'
import { useForm } from "react-hook-form"

function PersonalData({ dataManager, onNext, onBack }) {
  const { data, setData } = dataManager;
  const {
    register,
    handleSubmit,
    getFieldState,
    formState: {errors, isValid}
  } = useForm({mode: "onChange"})

  const onChange = (e) => {
    setData({
      ...data,
      personal: { ...data.personal, [e.target.name]: e.target.value },
    });
  };

  async function sendClientInfos(data) {
    let doc = await saveClientInfos(data.personal);
  }

  const onSubmit = (e) => {
    sendClientInfos(data);
    onNext();
  };

  return (
    <Box className={styles.personalBox}>
        <h3>Você já conhece o Consórcio do Banco do Brasil?</h3>
        <h4>
          Informe seus dados para simular e encontre o consórcio ideal para
          você.
        </h4>
        <form onSubmit={handleSubmit(onSubmit)} 
          className={styles.formContainer} 
          action="#"
        >
          <div className={styles.formGrid}>
          <Input
                label={"Nome *"}
                value={data.personal?.name}
                type="text"
                {...register("name", {
                  required: true, 
                  minLength: 4,
                  onChange: onChange,
                })}
                placeholder="Nome"
                style={
                  errors?.name ? 
                    { border: "1px solid red" } : 
                    getFieldState("name")?.isDirty ? 
                      { border: "1px solid green"} : {}
                }
              />
              <Input
                mask="999.999.999-99"
                value={data.personal?.cpf}
                label={"CPF *"}
                className={styles.formInput}
                {...register("cpf", {
                  required: true,
                  onChange: onChange,
                  pattern: {
                    value: /(\d{3}\.?\d{3}\.?\d{3}-?\d{2})|(\d{2}\.?\d{3}\.?\d{3}?\d{4}-?\d{2})/
                  } 
                })}
                placeholder="CPF"
                style={
                  getFieldState("cpf")?.invalid ? 
                    { border: "1px solid red" } : 
                    getFieldState("cpf")?.isDirty ? 
                      { border: "1px solid green"} : {}
                }
              />
              <Input
                label={"Email *"}
                value={data.personal?.email}
                className={styles.formInput}
                type="email"
                {...register("email", {
                  required: true, 
                  onChange: onChange,
                  pattern: {
                    value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
                  }
                })}
                placeholder="Email"
                style={
                  getFieldState("email")?.invalid ? 
                    { border: "1px solid red" } : 
                    getFieldState("email")?.isDirty ? 
                      { border: "1px solid green"} : {}
                }
              />
              <Input
                label={"Telefone *"}
                mask="(99) 99999-9999"
                className={styles.formInput}
                value={data.personal?.celular}
                type="tel"
                {...register("celular", {
                  required: true,
                  onChange: onChange,
                  pattern: {
                    value: /[(](\d{2})[)][-. ]?(\d{1}?\d{4}|\d{4})[-. ]?(\d{4})/
                  }
                })}
                placeholder="Telefone"
                style={
                  getFieldState("celular")?.invalid ? 
                    { border: "1px solid red" } : 
                    getFieldState("celular")?.isDirty ? 
                      { border: "1px solid green"} : {}
                }
              /> 
          </div>       
              <div className={styles.buttons}>
                <div className={styles.formAuth}>
                      <input 
                        {...register("agreement", {required: true})} 
                        className={styles.formCheck} 
                        type="checkbox"
                      />
                      Autorizo a Guerra Digital, Banco do Brasil e a BB Consórcios a
                      armazenarem e utilizarem os meus dados.
                </div>
                <div className={styles.actions}>
                  <Button outline onClick={onBack}>
                    <FiArrowLeft style={{strokeWidth: 3}}/>
                    Voltar    
                  </Button>
                  <Button disabled={!isValid} type="submit">
                    Continuar
                    <FiArrowRight style={{strokeWidth: 3}}/>
                  </Button>
                </div>
              </div>     
        </form>
      </Box>
  );
}
export default PersonalData;
